import React, { useEffect, useState } from "react";

import classificationService from "@plannel/services/ip/classification-service";
import { Autocomplete, TextField } from "@mui/material"
import debug from "@plannel/utils/debug-util";
import reduxUtil from "@plannel/utils/redux-util";
import { useDispatch } from "react-redux";
import { isEmpty, isEqual } from "lodash";
import { useTranslation } from "react-i18next";

const REDUX_CLASSIFICATION_FILTER = "CLASSIFICATION_FILTER";
/* statusFilter is Array */
const ClassificationFilter = ({ viewName, classificationValue, onChangeFilter, statusFilters = [] }) => {
  const { t } = useTranslation();

  const reduxDispatch = useDispatch();
  const classificationDataListReduxState = reduxUtil.getViewState(REDUX_CLASSIFICATION_FILTER);

  const [classificationDataList, setClassificationDataList] = useState(classificationDataListReduxState?.classification ? classificationDataListReduxState.classification : []);
  const [classificationFilterDataList, setClassificationFilterDataList] = useState([]);

  const onChangeHandler = (_, value) => {
    onChangeFilter(value);

    const createClassificationReduxState = reduxUtil.createObjectState(viewName, { classification: value });
    reduxDispatch(reduxUtil.updateViewState(createClassificationReduxState));
  }
  
  /* Classification Data Result Filtering [Status = READY] */
  const classificationDataStatusFilter = (results) => {
    let resultsFilter = [];

    if(!isEmpty(statusFilters)) {
      for (const result of results) {
        if (statusFilters.includes(result.statusCd)) {
          resultsFilter.push(result);
        }
      }
    } else {
      resultsFilter = results;
    }

    /* 기억 하고있는 redux data가 제거되거나 변경되는경우 dropdown list에 데이터가 존재하는지 체크하는 변수 */
    const existSelectedValueInResults = resultsFilter.find(result => isEqual(result.id, classificationValue?.id));

    /* Defualt Classification Setting */
    if (!isEmpty(resultsFilter)) {
      if (isEmpty(existSelectedValueInResults)) {
        onChangeHandler(null, resultsFilter[0]);
      } else {
        onChangeHandler(null, existSelectedValueInResults);
      }
    }

    return resultsFilter;
  }

  const getClassificationData = () => {
    /* 이전에 불러온 Dropdown data list가 존재하는경우 다시 가져오지 않음. */
    if (isEmpty(classificationDataListReduxState?.classification)) {
      const params = { pagination: false, orderByColumn: "updatedTs", sortType: "desc" };
      let classificatioResultData = [];

      classificationService.getAll(params)
        .then(response => {
          const { results } = response.data;
          if(!isEmpty(results)) {
            classificatioResultData = results;
          }
          
          const classificatioFilterData = classificationDataStatusFilter(classificatioResultData);

          setClassificationDataList(classificatioResultData);
          setClassificationFilterDataList(classificatioFilterData);
        })
        .catch(e => {
          debug(e);
        })
        .then(() => {
          const createClassificationDataListReduxState = reduxUtil.createObjectState(REDUX_CLASSIFICATION_FILTER, { classification: classificatioResultData });
          reduxDispatch(reduxUtil.updateViewState(createClassificationDataListReduxState));
        })
    } else {
      setClassificationFilterDataList(classificationDataStatusFilter(classificationDataList));
    }
  }

  useEffect(() => {
    getClassificationData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Autocomplete
      key={"classification"}
      name={"classification"}
      options={classificationFilterDataList}
      getOptionLabel={option => option?.name}
      value={classificationValue}
      onChange={onChangeHandler}
      isOptionEqualToValue={(option, value) => option.name === value?.name}
      size="small"
      disableClearable
      sx={{ mr: 1, minWidth: 240 }}
      componentsProps={{
        paper: { sx: { width: 240 } }
      }}
      renderInput={(params) => (
        <TextField {...params} label={t("classification")} />
      )}
    />
  )
}

const reloadClassificationFilter = (reduxDispatch) => {
  const classificationReduxFilterState = reduxUtil.getViewState(REDUX_CLASSIFICATION_FILTER);

  reduxDispatch(reduxUtil.removeViewState(classificationReduxFilterState));
}

export default React.memo(ClassificationFilter);
export { reloadClassificationFilter };